import Tool from "../Tool";

const AbstractRectangularTool = Tool.extend({
  constructor(editor) {
    Tool.call(this, editor);
    this.selecting = false;
  },

  dragStart(x, y) {
    if(!this.editor.selection) {
      this.editor.startSelection(x, y);
      this.selecting = true;
    } else {
      Tool.prototype.dragStart.call(this, x, y);
    }
  },

  dragMove(x, y) {
    if(this.selecting) {
      this.editor.setSelectionEnd(x, y);
    } else {
      Tool.prototype.dragMove.call(this, x, y);
    }
  },

  dragEnd(x, y) {
    if(this.selecting) {
      this.dragMove(x, y);
      this.selecting = false;
    } else {
      Tool.prototype.dragEnd.call(this, x, y);
    }
  },

  selectionAction() {
    this.execute();
  },

  execute() {
    const selection = this.editor.selection;

    if(!selection) return;

    const x = selection.getX().toFixed(6);
    const y = selection.getY().toFixed(6);
    const w = selection.getW().toFixed(6);
    const h = selection.getH().toFixed(6);

    const url = this.editor.makeURL(this.getUrl(x, y, w, h));

    AJAX.send({
      scope: this.editor.getAJAXScope(),
      callback: (data) => {
        this.editor.setURL(data.pics.http);
        this.editor.history.push();
      },
      url
    });
  },

  getUrl(x, y, w, h) {
    throw new Error("This method should be implemented in a subclass.");
  },

  leave() {
    this.editor.clearSelection();
  },

  pinchStart(x, y) {
    if(!this.selecting) Tool.prototype.pinchStart.call(this, x, y);
  },

  pinchMove(dist, x, y) {
    if(!this.selecting) Tool.prototype.pinchMove.call(this, dist, x, y);
  },

  pinchEnd(x, y) {
    if(!this.selecting) Tool.prototype.pinchEnd.call(this, x, y);
  },
});

export default AbstractRectangularTool;
